import { Link } from "gatsby"
import React from "react"
import PropTypes from "prop-types"
import Layout from "@/components/Layout"
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import NavBar from "@/components/NavBar"
import BarChart from "@/components/BarChart"
import ArrowKeysReact from 'arrow-keys-react';
import CompletionBar from "@/components/CompletionBar"

import "./styles.css"

export const frontmatter = {
  title: 'Means and Variability',
  id: '84e278d9-b5e5-4265-90e6-374b075beb7e',
  figure: '2.43',
}

class InteractiveMeansVariability extends React.PureComponent {

  initalState = {
    ...frontmatter,
    panel: 1,
    selected: null,
    showFeedback: false,
    data: [1, 1, 3, 5, 3, 2, 1, 0, 1],
    mean: 4.4,
    sd: 1.9,
    showNext: [false, false, false, false],
    showPrev: [false, true, true, true],
    completed: false
  };

  constructor(props) {
    super(props);

    this.state = JSON.parse(JSON.stringify(this.initalState));
    // this.state = Object.assign({}, this.initalState);
    this.increment = this.increment.bind(this)
    this.decrement = this.decrement.bind(this)
    this.generateTable = this.generateTable.bind(this)
    this.generatePanel = this.generatePanel.bind(this)
    this.generateNumberToolBar = this.generateNumberToolBar.bind(this)
    this.buttonKeyListener = this.buttonKeyListener.bind(this)

    this.reset = this.reset.bind(this)
    this.addVal = this.addVal.bind(this)
    this.subtractVal = this.subtractVal.bind(this)
    this.calculateMean = this.calculateMean.bind(this)
    this.calculateSD = this.calculateSD.bind(this)
    this.generateChartDescription = this.generateChartDescription.bind(this)
  }

  buttonKeyListener(e) {
    if (e.ctrlKey) return
    if (e.key === "=") {
      this.addVal()
    }
    if (e.key === "-") {
      this.subtractVal()
    }
  }

  reset() {
    this.setState(JSON.parse(JSON.stringify(this.initalState)));
  }

  addVal() {
    if (this.state.data[this.state.selected - 1] < 10) {

      switch (this.state.panel) {
        case 1:
          if (this.state.data[this.state.selected - 1] < 6) {
            this.state.showNext[0] = true;

            var temp = this.state.data.slice();
            temp[this.state.selected - 1] = temp[this.state.selected - 1] + 1
            this.setState({ data: temp })
            this.calculateMean(temp)
            this.calculateSD(temp)
          }
          break;

        case 2:
          if (this.state.data[this.state.selected - 1] < 2) {
            this.state.showNext[1] = true;

            var temp = this.state.data.slice();
            temp[this.state.selected - 1] = temp[this.state.selected - 1] + 1
            this.setState({ data: temp })
            this.calculateMean(temp)
            this.calculateSD(temp)
          }
          break;

        case 3:
          if (this.state.data[this.state.selected - 1] < 2) {
            this.state.showNext[2] = true;

            var temp = this.state.data.slice();
            temp[this.state.selected - 1] = temp[this.state.selected - 1] + 1
            this.setState({ data: temp })
            this.calculateMean(temp)
            this.calculateSD(temp)
          }
          break;

        case 4:
          var temp = this.state.data.slice();
          temp[this.state.selected - 1] = temp[this.state.selected - 1] + 1
          this.setState({ data: temp })
          this.calculateMean(temp)
          this.calculateSD(temp)
          break;
      }
    }
  }

  subtractVal() {
    if (this.state.data[this.state.selected - 1] > 0) {
      if (this.state.panel == 4) {
        var temp = this.state.data.slice();
        temp[this.state.selected - 1] = temp[this.state.selected - 1] - 1
        this.setState({ data: temp })

        this.calculateMean(temp)
        this.calculateSD(temp)
      }
    }
  }

  calculateMean(data) {
    let sum = 0
    let nums = 0
    for (let i = 0; i < data.length; i++) {
      nums += data[i]
      for (let j = 0; j < data[i]; j++) {
        sum += (i + 1)
      }
    }
    this.setState({ mean: (sum / nums).toFixed(1) })
  }

  calculateSD(data) {
    let sum = 0
    let nums = 0
    for (let i = 0; i < data.length; i++) {
      nums += data[i]
      for (let j = 0; j < data[i]; j++) {
        const dif = (i + 1) - parseInt(this.state.mean)
        sum += (dif * dif)
      }
    }
    sum /= nums
    sum = Math.sqrt(sum)
    this.setState({ sd: sum.toFixed(1) })
  }

  generateChartDescription() {

    let arr = []
    let group = []
    // [ [0,1], [2], [3], etc]
    for (let i = 0; i < this.state.data.length; i++) {
      let curr = this.state.data[i]

      if (i > 0) {
        let last = this.state.data[i - 1]

        if (curr === last) {
          group.push(i + 1)
        }
        else {
          arr.push(group)
          group = [i + 1]
        }

        continue
      }

      group = [1]
    }
    arr.push(group)

    let processedStrs = []
    for (const set of arr) {
      let str = ''

      if (set.length === 1) {
        let idx = set[0] - 1

        str = `${idx + 1} has ${this.state.data[idx]}`
      }
      else {
        str = set.slice(0, set.length - 1).join(', ') + ' and ' + set[set.length - 1] + ' with ' + this.state.data[set[0]]
      }

      processedStrs.push(str)
    }

    let dataStr = processedStrs.slice(0, processedStrs.length - 2).join('; ') + '; and ' + processedStrs[processedStrs.length - 1] + '.'

    return "A graph shows how many people got this score on the vertical axis. Points is listed on the horizontal axis. There is a standard distribution with " + dataStr
  }

  render() {
    return (
      <div>
        <div style={{ display: "inline-block" }} aria-live="polite">
          {this.generatePanel(this.state.panel)}
        </div>
        <NavBar
          onClickNext={this.increment}
          onClickPrev={this.decrement}
          onClickReset={this.reset}
          showPrev={this.state.showPrev[this.state.panel - 1]}
          showNext={this.state.showNext[this.state.panel - 1]}
        />
        <CompletionBar completed={this.state.completed} />
      </div>
    );
  }

  increment() {
    if (this.state.panel < 4 && this.state.showNext[this.state.panel - 1]) {
      this.setState({ panel: this.state.panel + 1, selected: null })
    }
  }

  decrement() {
    if (this.state.panel > 1) {
      this.setState({ panel: this.state.panel - 1, selected: null })
    }
  }

  generateTable() {

    const tableStyle = {
      fontFamily: 'arial',
      borderCollapse: 'collapse',
      width: '100%',
      margin: '5px'
    }

    const tableBodyStyle = {
      border: '1px solid black',
      textAlign: 'left',
      paddingLeft: '10px'
    }

    const tableBodyNumStyle = {
      border: '1px solid black',
      textAlign: 'center'
    }

    return (
      <table style={tableStyle} role="presentation" aria-live="polite" aria-relevant="additions">
        <tbody style={tableBodyStyle}>
          <tr>
            <td style={tableBodyStyle}>Mean</td>
            <td style={tableBodyNumStyle}>{this.state.mean}</td>
          </tr>
          <tr>
            <td style={tableBodyStyle}>Standard deviation</td>
            <td style={tableBodyNumStyle}>{this.state.sd}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  generateNumberToolBar() {

    return (
      <div>
        <span id="keyboardhint" className="sr-only">You can use the plus and minus keys to change values.</span>
        <ButtonToolbar style={{ height: '100%', paddingLeft: '33px' }}>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 1 }) }} active={this.state.selected === 1} disabled={this.state.panel != 4 && this.state.panel != 2 ? true : false} size="sm"> 1 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 2 }) }} active={this.state.selected === 2} disabled={this.state.panel != 4 ? true : false} size="sm"> 2 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 3 }) }} active={this.state.selected === 3} disabled={this.state.panel != 4 ? true : false} size="sm"> 3 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 4 }) }} active={this.state.selected === 4} disabled={(this.state.panel != 4 && this.state.panel != 1) ? true : false} size="sm"> 4 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 5 }) }} active={this.state.selected === 5} disabled={this.state.panel != 4 ? true : false} size="sm"> 5 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 6 }) }} active={this.state.selected === 6} disabled={this.state.panel != 4 ? true : false} size="sm"> 6 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 7 }) }} active={this.state.selected === 7} disabled={this.state.panel != 4 ? true : false} size="sm"> 7 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 8 }) }} active={this.state.selected === 8} disabled={this.state.panel != 4 ? true : false} size="sm"> 8 </Button>
          <Button aria-describedby="keyboardhint" className="graph-button" onKeyDown={this.buttonKeyListener} onClick={() => { this.setState({ selected: 9 }) }} active={this.state.selected === 9} disabled={this.state.panel != 4 && this.state.panel != 3 ? true : false} size="sm"> 9 </Button>
        </ButtonToolbar>
        <div style={{ marginRight: '2px' }}>
          <Button className="graph-button" onClick={this.addVal} size="sm"> + </Button>
          <Button className="graph-button" disabled={this.state.panel != 4} onClick={this.subtractVal} size="sm"> - </Button>
        </div>

      </div>
    )
  }

  generatePanel(panel) {
    var barData;
    if (this.state.panel === 1 && this.state.showNext[this.state.panel - 1]) {
      barData = [1, 1, 3, 6, 3, 2, 1, 0, 1];
      this.setState({ mean: 4.4, sd: 1.8 });
    }
    else if (this.state.panel === 2 && this.state.showNext[this.state.panel - 1]) {
      barData = [2, 1, 3, 6, 3, 2, 1, 0, 1]
      this.setState({ mean: 4.2, sd: 1.9 });
    }
    else if (this.state.panel === 3 && this.state.showNext[this.state.panel - 1]) {
      barData = [2, 1, 3, 6, 3, 2, 1, 0, 2]
      this.setState({ mean: 4.5, sd: 2.2 });
    }
    else {
      barData = this.state.data;
      this.calculateMean(barData)
      this.calculateSD(barData)
    }

    const data = {
      labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      datasets: [{
        backgroundColor: 'Blue',
        data: barData,
      }]
    }

    const options = {
      legend: {
        display: false
      },
      tooltips: {
        enabled: false,
        callbacks: {
          label(tooltipItem) {
            return tooltipItem.yLabel;
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            autoSkip: false,
            min: 0,
            max: 10
          },
          afterBuildTicks(scale) {

          },
          beforeUpdate(oScale) {

          }
        }],
        xAxes: [{
          gridLines: {
            lineWidth: 0,
            color: "rgba(255,255,255,0)"
          },
          ticks: {
            display: false // this will remove only the label
          }
        }]
      }
    }
    const textStyle = { textAlign: "left", marginBottom: "10px" }

    switch (panel) {
      case 1:
        return (
          <div>
            <div style={{ display: "inline-block", width: "70%" }}>
              <span id="chartdesc" className="sr-only" aria-live="polite">{this.generateChartDescription()}</span>
              <div aria-labelledby="chartdesc"><BarChart data={data} options={options} /></div>
              {this.generateNumberToolBar()}
            </div>
            <div style={{ display: "inline-block", width: "70%" }}>{this.generateTable()}</div>
            <div style={textStyle}>
              You can add or subtract numbers to the distribution on the graph and see how the changes affect the
              mean and standard deviation. Let’s start by adding a 4: Select the number 4 button
              and then the plus key or button.
            </div>
          </div>
        )
        break;
      case 2:
        return (
          <div>
            <div style={{ display: "inline-block", width: "70%" }}>
              <span id="chartdesc" className="sr-only" aria-live="polite">{this.generateChartDescription()}</span>
              <div aria-labelledby="chartdesc"><BarChart data={data} options={options} /></div>
              {this.generateNumberToolBar()}
            </div>
            <div style={{ display: "inline-block", width: "70%" }}>{this.generateTable()}</div>
            <div style={textStyle}>
              Notice that when you add a number close to the mean, neither the mean nor the
              standard deviation change much. Now try adding a 1.
            </div>
          </div>
        )
        break;
      case 3:
        return (
          <div>
            <div style={{ display: "inline-block", width: "70%" }}>
              <span id="chartdesc" className="sr-only" aria-live="polite">{this.generateChartDescription()}</span>
              <div aria-labelledby="chartdesc"><BarChart data={data} options={options} /></div>
              {this.generateNumberToolBar()}
            </div>
            <div style={{ display: "inline-block", width: "70%" }}>{this.generateTable()}</div>
            <div style={textStyle}>
              Notice that when you add a number lower than the mean, the mean decreases
              but the standard deviation increases. Finally, try adding a 9.
            </div>
          </div>
        )
        break;
      case 4:
        window.parent.postMessage(JSON.stringify({
          key: "ippip-" + window.location.href.split("/").filter(b => !b.startsWith("index.html") && b.length >= 3).pop(),
          message: {
            type: 'step_completed',
            payload: {
              step: 0
            }
          }
        }), '*')
        window.parent.postMessage({
          id: this.state.id,
          action: 'completed',
          eventTime: new Date().toISOString(),
          type: 'activitysubmission',
          url: window.location.href,
        }, '*');
        this.state.completed = true;

        return (
          <div>
            <div style={{ display: "inline-block", width: "70%" }}>
              <span id="chartdesc" className="sr-only" aria-live="polite">{this.generateChartDescription()}</span>
              <div aria-labelledby="chartdesc"><BarChart data={data} options={options} /></div>
              {this.generateNumberToolBar()}
            </div>
            <div style={{ display: "inline-block", width: "70%" }}>{this.generateTable()}</div>
            <div style={textStyle}>
              When you add a number much higher than the mean, both the mean and the
              standard deviation increase. Now try adding and subtracting numbers to see how each
              changes the mean and standard deviation.
            </div>
          </div>
        )
        break;
    }
  }
}


const PageMeansVariability = () => (
  <Layout {...frontmatter}>
    <InteractiveMeansVariability />
  </Layout>
)

export default PageMeansVariability
